const A = "/brand";
const btnGhostWhite =
  "inline-flex items-center justify-center gap-2 border border-[#159E9A]/40 text-[#159E9A] rounded-[10px] px-6 py-3 text-sm font-medium hover:bg-[#159E9A] hover:text-white transition-colors";

export function GratitudeRoom() {
  return (
    <section data-testid="gratitude-section" className="relative overflow-hidden bg-[#EFF5F4]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center">
          <div className="lg:col-span-7 lg:pr-12 xl:pr-16 reveal">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-[#1C1917] mb-6">
              For Over 5 Years, We've Closed Every Day With Joy.
            </h2>
            <div className="space-y-4 text-[#57534E] leading-relaxed max-w-xl">
              <p>
                Every night at 1am Eastern, people from around the world gather
                live on Clubhouse for Life Hacks for Night Owls — a free nightly
                gratitude practice designed to help you reflect, reframe, and
                realign before sleep.
              </p>
              <p>
                Some are ending their day.
                <br />
                Some are beginning it.
              </p>
              <p>
                No performance.
                <br />
                No pressure.
                <br />
                Just presence.
              </p>
              <p>
                Every night.
                <br />
                Through holidays.
                <br />
                Through hard seasons.
                <br />
                Through ordinary Tuesdays.
              </p>
              <p className="font-display text-xl text-[#1C1917]">For over five years now.</p>
            </div>
            <a
              href="https://www.clubhouse.com/invite/jg0SDleYG8wJXArV0Q612J63dkZYCWL1w:qIXUL9DPkuBYVeGhQHFM-lx1fEvADoxSz_nmaJiNAwk"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gratitude-cta"
              className={`mt-8 inline-block ${btnGhostWhite}`}
            >
              Join Tonight on Clubhouse →
            </a>
          </div>

          <div className="lg:col-span-5 reveal relative mt-8 lg:mt-0">
            <div className="relative aspect-[3/4] lg:aspect-[2/3]">
              <div
                className="absolute inset-y-0 left-0 w-32 lg:w-48 z-[1]"
                style={{ background: "linear-gradient(to left, transparent 0%, #EFF5F4 100%)" }}
              />
              <img
                src={`${A}/blueprint4joy-home-nightly-room-portrait.jpg`}
                alt="Lara curled up in a teal chair at night during the Nightly Gratitude Room call."
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
